














































































































































































































































import {Component, Prop} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import MenuReportDialogsMixin from '@/views/layout/navigation/mixins/menu-report-dialogs-mixin';
import DomainsApi from '@/services/rest/bemob/domains';
import CampaignApi from '@/services/rest/bemob/campaign';
import TrafficSourceApi from '@/services/rest/bemob/traffic-source';
import moment from 'moment';

@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons
  }
})
export default class CampaignLinksDialog extends mixins(MenuReportDialogsMixin, Form) {
  @Prop({ default: {} })
  data: any;
  campaignApi: CampaignApi = new CampaignApi();

  step: number = 1;
  show: boolean = false;
  edit: boolean = true;
  trackingDomain = null;
  loading: boolean = false;
  campaign_id: string = '';
  campaign: any = {};
  trafficSourceApi: TrafficSourceApi = new TrafficSourceApi();
  domainsApi: DomainsApi = new DomainsApi();

  form: any = {
    clickUrl: '',
    multiClickUrl: '',
    campaignRedirectUrl: '',
    campaignRedirectTestUrl: '',
    campaignLandingPixel: '',
    campaignJsRedirect: '',
    campaignImpressionsUrl: '',
    campaignImpressionsPixel: '',
    postbackUrl: '',
    trackingPixelUrl: '',
    trackingPixel: '',
    trackingScript: '',
    campaignRedirectUrlQR: '',
    campaignRedirectTestUrlQR: '',
  }

  async mounted() {
    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }
    await this.load();
  }

  openLpPixelDialog() {
    this.bus.emit('open-dialog', { name: 'LpPixel', data: { id: this.campaign_id } });
  }

  openTrackConversionsWithNoClickIdsDialog({linkType}) {
    this.bus.emit('open-dialog', {
      name: 'TrackConversionsWithNoClickIds',
      data: { 
        campaign: this.campaign,
        linkType
      } 
    });
  }

  isNextDnsRecordValidationAfterYear(trackingDomain) {
    return moment().add(1, 'year').isBefore(trackingDomain.nextDnsRecordValidation)
  }

  get tooltipUserAgent(){
    return this.isFreePlan 
      ? 
      this.t('This is your campaign link which should pasted on the side of your traffic source.<br>If you are on Free or Basic plan, the link will be displayed with HTTP even when the SSL is issued for the domain. <br>In case your traffic source is requesting the campaign link with HTTPS only, you can add the \'S\' manually on the link on the side of traffic source.') 
      : 
      this.t('Your campaign link is displayed with HTTP, even when an SSL certificate is issued for the domain.<br>Copy this link and place it on the traffic source side.<br>A link with HTTP significantly speeds up the redirect.<br>If you want to place a link with HTTPS on the source side, then edit the link on the source side and replace HTTP with HTTPS.')
  }

  get isFreePlan(){
    return ['free','basic'].includes(this.$store.state.billing.planId)
  }


  async load() {
    const { user } = this.$store.state;

    this.campaign_id = this.data.id || this.$store.getters.selectedItem.id;

    this.loading = true;

    let trackingDomainId = user.trackingDomainId;

    this.$store.commit('loading', true);

    try {
      this.campaign = await this.campaignApi.get(this.campaign_id);

      if (this.campaign.trackingDomainId) {
        trackingDomainId = this.campaign.trackingDomainId;
      }

      this.trackingDomain = this.$store.getters.cache.trackingDomainsObject[trackingDomainId]

      let trafficSourceParams: any = [];

      if(this.campaign.trafficSourceId) {
        let trafficSource = await this.trafficSourceApi.get(this.campaign.trafficSourceId);

        if (trafficSource.costParam) {
          trafficSourceParams.push(trafficSource.costParam + '=' + trafficSource.costPlaceholder);
        }

        if (trafficSource.extClickIdParam) {
          trafficSourceParams.push(trafficSource.extClickIdParam + '=' + trafficSource.extClickIdPlaceholder);
        }

        for (let i = 1; i <= 10; i++) {
          if (trafficSource['custom' + i + 'Param']) {
            trafficSourceParams.push(trafficSource['custom' + i + 'Param'] + '=' + trafficSource['custom' + i + 'Placeholder']);
          }
        }
      }

      trafficSourceParams = trafficSourceParams.length > 0 ? '?' + trafficSourceParams.join('&') : '';
      let jsRedirectHref = `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/go-js/${this.campaign.id}`;
      // let jsRedirect = '!function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="' + jsRedirectHref + '?"+window.location.search.substring(1);var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}();';
      let jsRedirect = '!function(){var a=document.createElement("script");a.type="text/javascript",a.src="' + jsRedirectHref + '?"+window.location.search.substring(1);var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}();';
      jsRedirect = '<scr' + 'ipt type="text/javascript">' + jsRedirect + '</scr' + 'ipt>';

      let lpPixelHref = `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/landing/${this.campaign.id}?callback=REPLACE&rule=REPLACE&path=REPLACE&landing=REPLACE`;
      let lpPixel = '!function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="' + lpPixelHref + '&"+window.location.search.substring(1);var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}();';
      lpPixel = '<scr' + 'ipt type="text/javascript">' + lpPixel + '</scr' + 'ipt>';

      let trackingUrls = {
        clickUrl: `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/click`,
        multiClickUrl: `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/click/1`,
        campaignRedirectUrl: `https://${this.trackingDomain.domain}/go/${this.campaign.id}${trafficSourceParams}`,
        campaignRedirectTestUrl: `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/test/go/${this.campaign.id}${trafficSourceParams}`,
        campaignLandingPixel: lpPixel,
        campaignJsRedirect: jsRedirect,
        campaignImpressionsUrl: `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/impression/${this.campaign.id}${trafficSourceParams}`,
        campaignImpressionsPixel: `<img src="${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/impression/${this.campaign.id}${trafficSourceParams}" alt="" border="0" width="1" height="1">`,
        postbackUrl: `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/postback?cid=REPLACE&payout=OPTIONAL&txid=OPTIONAL&status=OPTIONAL`,
        trackingPixelUrl: `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/conversion.gif?cid=OPTIONAL&payout=OPTIONAL&txid=OPTIONAL&status=OPTIONAL`,
        trackingPixel: `<img src="${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/conversion.gif?cid=OPTIONAL&payout=OPTIONAL&txid=OPTIONAL&status=OPTIONAL" width="1" height="1" border="0" alt="" />`,
        trackingScript: `<scr` + `ipt async type="text/javascript" src="${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/conversion.js?cid=OPTIONAL&payout=OPTIONAL&txid=OPTIONAL&status=OPTIONAL"></scr` + `ipt>`,
        campaignImpressionsUrlTxt: `${this.trackingDomain.httpsAvailable ? 'https' : 'http'}://${this.trackingDomain.domain}/conversion.txt?cid=REPLACE&payout=OPTIONAL&txid=OPTIONAL&status=OPTIONAL`,
        campaignRedirectUrlQR: '',
        campaignRedirectTestUrlQR: '',
      };

      trackingUrls.campaignRedirectUrlQR = 'https://api.qrserver.com/v1/create-qr-code/?size=177x177&margin=10&data=' + (trackingUrls.campaignRedirectUrl ? encodeURIComponent(String(trackingUrls.campaignRedirectUrl).trim()) : '');
      trackingUrls.campaignRedirectTestUrlQR = 'https://api.qrserver.com/v1/create-qr-code/?size=177x177&margin=10&data=' + (trackingUrls.campaignRedirectTestUrl ? encodeURIComponent(String(trackingUrls.campaignRedirectTestUrl).trim()) : '');

      this.form = trackingUrls;
      this.show = true;
    } catch(err) {
      this.bus.emit('toast-error', this.t('Error occurred while dialog opening'));
      this.close()
    } finally {
      this.loading = false;
      this.$store.commit('loading', false);
    }
  }

  handleEdit() {
    this.close();
    this.bus.emit('open-dialog', { name: 'EditCampaign', data: { id:this.campaign_id } });
  }

  close() {
    this.$emit('close');
  }

}
